/** Present legacy store rich text consistently without changing catalogue content. */
class RichText extends HTMLElement {
  connectedCallback() {
    const normalize = value => value.toLowerCase().replace(/[^\p{L}\p{N}]/gu, '');
    const title = normalize(this.dataset.title || '');
    const heading = this.querySelector('h1,h2,h3,h4,h5,h6');
    if (title && heading && normalize(heading.textContent) === title) heading.remove();
    for (const element of this.querySelectorAll('p,h1,h2,h3,h4,h5,h6,.spacer30,.contactboxes,.row > .col-xs-12')) {
      if (!element.textContent.trim() && !element.querySelector('img,iframe,video,svg,input,button')) element.remove();
    }
    for (const link of this.querySelectorAll('a[href^="mailto:"]')) {
      const email = link.textContent.trim();
      if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) link.setAttribute('href', `mailto:${email}`);
    }
    const headings = [...this.querySelectorAll('h1,h2,h3,h4,h5,h6')];
    const isProse = element => element.textContent.trim().length > 160 || element.closest('li');
    const firstLevel = Math.min(6, ...headings.filter(element => !isProse(element)).map(element => Number(element.tagName[1])));
    let previousLevel = 1;
    for (const element of headings) {
      const prose = isProse(element);
      const level = Math.min(6, previousLevel + 1, Math.max(2, Number(element.tagName[1]) - firstLevel + 2));
      if (!prose) previousLevel = level;
      if (!prose && element.tagName === `H${level}`) continue;
      const replacement = document.createElement(prose ? 'p' : `h${level}`);
      for (const attribute of element.attributes) replacement.setAttribute(attribute.name, attribute.value);
      replacement.append(...element.childNodes);
      element.replaceWith(replacement);
    }
  }
}
if (!customElements.get('ac-rich-text')) customElements.define('ac-rich-text', RichText);

class DeferredVideo extends HTMLElement {
  connectedCallback() {
    const button = this.querySelector('button');
    const template = this.querySelector('template');
    if (!button || !template) return;
    const title = template.content.querySelector('iframe')?.title || button.textContent.trim();
    button.setAttribute('aria-label', `${button.textContent.trim()}: ${title}`);
    button.addEventListener('click', () => {
      const iframe = template.content.querySelector('iframe')?.cloneNode(true);
      if (!(iframe instanceof HTMLIFrameElement)) return;
      const url = new URL(iframe.getAttribute('src'), window.location.href);
      url.searchParams.set('autoplay', '1');
      iframe.src = url.href;
      iframe.title = title;
      iframe.allow = `${iframe.allow}; autoplay`;
      this.replaceChildren(iframe);
      iframe.focus();
    }, { once: true });
  }
}
if (!customElements.get('ac-deferred-video')) customElements.define('ac-deferred-video', DeferredVideo);
